// DS: i4.1
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const User: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M12 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10zM7 15h10a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a3 3 0 0 1 3-3z" />
      </g>
    </svg>
  </IconWrap>
);
User.displayName = 'User';

export default User;
